// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viewport-toogle__mobile[data-v-8d375a64]{display:none}@media (max-width:800px){.viewport-toogle__desktop[data-v-8d375a64]{display:none}.viewport-toogle__mobile[data-v-8d375a64]{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
